module.exports = __webpack_public_path__ + "img/68.6483c9f7.jpg";